import { getFilesFromDataTransfer } from 'helpers/dataTransfer';
import DragAndDropManager, { DragAndDropManagerConfig } from './base';

export default class DragAndDropFilesManager extends DragAndDropManager<File[]> {
    constructor(config: Omit<DragAndDropManagerConfig<File[]>, 'extractor'>) {
        const finalConfig = _({}).extend(config, {
            extractor: getFilesFromDataTransfer
        }) as DragAndDropManagerConfig<File[]>;

        super(finalConfig);
    }
}